export * from './auth-form.component';
export * from './auth-intern.component';
export * from './auth-facebook.component';
export * from './auth-google.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/auth/auth-form/index.ts